import { toast } from "react-toastify";
import { commonservices } from "./CommonServices";

export const apiResponse = (isMsgDisplay, data, setLoading) => {
    if (data?.status_code === 0) {
        if (isMsgDisplay) {
            if (setLoading) {
                setLoading(false);
            }
            toast.error(data?.message);
        }
        if (setLoading) {
            setLoading(false);
        }
        return {
            isValidate: false,
            data: data,
        };
    } else if (data?.status_code === 1) {
        if (setLoading) {
            setLoading(false);
        }
        if (isMsgDisplay) toast.success(data?.message);
        return {
            isValidate: true,
            data: data,
        };
    } else if (data?.status_code === 2) {
        commonservices.clearLocalStorage();
        window.location.pathname = "/";
    } else if (data?.name === "AxiosError") {
        if (setLoading) {
            setLoading(false);
        }
        if (data?.response?.status_code === 422) {
            return {
                status: 0,
                message: toast.error("Unprocessable Entity"),
            };
        } else if (data?.response?.status_code === 401) {
            commonservices.clearLocalStorage();
            window.location.reload();
            return {
                status: 2,
                message: toast.error("you are un-authorised please re-login"),
            };
        } else if (data?.response?.status_code === 405) {
            return {
                status: 0,
                message: toast.error("Method Not Allowed"),
            };
        } else if (data?.response?.status_code === 500) {
            return {
                status: 0,
                message: toast.error("Internal Server Error"),
            };
        } else {
            return {
                status: 0,
                message: toast.error(
                    "Something wrong happened, please try again later"
                ),
            };
        }
    } else {
        if (setLoading) {
            setLoading(false);
        }
    }
};
